import { Injectable, inject } from '@angular/core';
import { FilterApi } from 'src/api';
import { Observable } from 'rxjs';

@Injectable()
export class FilterService {
  private readonly filterApi = inject(FilterApi);

  getAllMachineSerials$(): Observable<string[]> {
    return this.filterApi.getAllMachineSerial$();
  }

  getInitialRotorTypes$(): Observable<string[]> {
    return this.filterApi.getInitialRotorTypes$();
  }

  searchForRotorTypes$(filterValue: string): Observable<string[]> {
    return this.filterApi.searchForRotorTypes$(filterValue);
  }
}
